import React from "react";
import {
  CONFIGURATION_LINK_PATH,
  CONFIGURATION_WEBHOOKS_PATH,
  CONFIGURATION_FIELD_MAPPINGS_PATH,
  CONFIGURATION_CUSTOM_OBJECTS_PATH,
  CONFIGURATION_DESTINATIONS_PATH,
  CONFIGURATION_SELECTIVE_SYNC_CONDITION_PRESETS_PATH,
  SFTP_TOGGLE_PATH,
} from "../../../router/RouterUtils";
import useAppContext from "../../context/useAppContext";
import useProductRestrictions from "../../shared/hooks/useProductRestrictions";
import PortalPageHeaderWrapper from "../../portal/PortalPageHeaderWrapper";
import compact from "lodash/compact";
import { UserType } from "../../../models/Entities";

type Props = { children: JSX.Element | JSX.Element[] };

const ConfigurationPageWrapper = ({ children }: Props) => {
  const { productRestrictions } = useProductRestrictions();
  const { isUserPrivileged, user } = useAppContext();
  const isDestinationsEnabled = user.is_destinations_enabled;

  return (
    <PortalPageHeaderWrapper
      title="Advanced"
      subtabs={compact([
        {
          label: "Webhooks",
          destination: CONFIGURATION_WEBHOOKS_PATH,
        },
        (isUserPrivileged || user.type === UserType.support) && {
          label: "Field Mapping",
          destination: CONFIGURATION_FIELD_MAPPINGS_PATH,
        },
        {
          label: "Selective Sync",
          destination: CONFIGURATION_SELECTIVE_SYNC_CONDITION_PRESETS_PATH,
        },
        isUserPrivileged && {
          label: "SFTP",
          destination: SFTP_TOGGLE_PATH,
        },
        user.type !== UserType.support && {
          label: "Merge Link",
          destination: CONFIGURATION_LINK_PATH,
        },
        isUserPrivileged &&
          productRestrictions?.are_custom_objects_enabled && {
            label: "Custom Objects",
            destination: CONFIGURATION_CUSTOM_OBJECTS_PATH,
          },
        isDestinationsEnabled && {
          label: "Destinations",
          destination: CONFIGURATION_DESTINATIONS_PATH,
        },
      ])}
    >
      {children}
    </PortalPageHeaderWrapper>
  );
};

export default ConfigurationPageWrapper;
